import { render, staticRenderFns } from "./ticket-chip.vue?vue&type=template&id=529970d2&scoped=true"
import script from "./ticket-chip.vue?vue&type=script&lang=js"
export * from "./ticket-chip.vue?vue&type=script&lang=js"
import style0 from "./ticket-chip.vue?vue&type=style&index=0&id=529970d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529970d2",
  null
  
)

export default component.exports